var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9993 22.2984H12.4002C10.9681 22.2984 9.59471 21.7295 8.58208 20.717C7.56947 19.7044 7.00061 18.331 7.00061 16.899V15.3242",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2994 25.0009L24.9992 22.3012L22.2994 19.6016",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00061 9.70117H19.5997C21.0318 9.70117 22.4051 10.27 23.4177 11.2826C24.4304 12.2951 24.9993 13.6685 24.9993 15.1005V16.7204",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70041 7L7.00061 9.69966L9.70041 12.3993",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon1);
export default __webpack_public_path__ + "static/media/Edit icon (1).ffb879d49e1d5bdb16ae46a6e8351263.svg";
export { ForwardRef as ReactComponent };